import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Link from "next/link";
import data from "data/linksData3.js"; // Adjust the path accordingly
import styles from "./LinksList.module.scss";

export default function LinksList() {
  const classes = styles;

  // Function to extract and process breadcrumb data
  const extractBreadcrumbData = (section) => {
    const breadcrumbThirdElement = section.breadcrumb[2];
    const subtitle = breadcrumbThirdElement.name;
    const href = breadcrumbThirdElement.href;
    const id = href.substring(
      href.indexOf("glossary/web-analytics#") + "glossary/web-analytics#".length
    );
    return { subtitle, id, links: section.links };
  };

  const groupedData = Object.values(data.web_analytics).map(
    extractBreadcrumbData
  );

  // Function to partition the data into columns
  const partitionData = (groupedData, parts) => {
    let result = Array.from({ length: parts }, () => []);
    let currentColumn = 0;

    groupedData.forEach((group) => {
      if (
        result[currentColumn].length + group.links.length >
        Math.ceil(groupedData.length / parts)
      ) {
        currentColumn = (currentColumn + 1) % parts;
      }
      result[currentColumn].push(group);
    });

    return result;
  };

  const dividedData = partitionData(groupedData, 3);

  return (
    <GridContainer>
      {dividedData.map((column, columnIndex) => (
        <GridItem key={columnIndex} xs={12} sm={4}>
          <List>
            {column.map((group, groupIndex) => (
              <React.Fragment key={groupIndex}>
                <ListItem id={group.id} className={classes.subtitle}>
                  {group.subtitle}
                </ListItem>
                {group.links.map((link, linkIndex) => (
                  <ListItem key={linkIndex} className={classes.listItem}>
                    <Link href={link.href}>{link.name}</Link>
                  </ListItem>
                ))}
              </React.Fragment>
            ))}
          </List>
        </GridItem>
      ))}
    </GridContainer>
  );
}
